import { Component, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { HostListener } from '@angular/core'
import { MiscService } from 'app/services/misc.service';

@Component({
  selector: 'app-nav',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class HeaderComponent {
  navbarCollapsed: boolean;
  pages: object[];
  pagesEN: object[];
  menuActive = false;
  FinnishSelected = false;

  constructor(
    private miscService: MiscService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
  ) {
    this.FinnishSelected = this.miscService.getLanguage();
    this.navbarCollapsed = true;
    this.pages = [
      { url: 'mita-ovat-energiatehokkuussopimukset', title: 'Mitä ovat energiatehokkuussopimukset?' },
      { url: 'ministerin-alkusanat', title: 'Ministerin alkusanat' },
      { url: 'mita-saavutimme-vuosina-2008-2016', title: 'Mitä saavutimme vuosina 2008-2016?' },
      { url: 'vapaaehtoisuuden-voimalla', title: 'Vapaaehtoisuuden voimalla' },
      { url: 'menestystekijat', title: 'Menestystekijät' },
      { url: 'takana-pitka-historia', title: 'Takana pitkä historia' },
      { url: 'valtio-tukee-energiatehokkuutta', title: 'Valtio tukee energiatehokkuutta' },
      { url: 'energiakatselmus-viitoittaa-tieta', title: 'Energiakatselmus viitoittaa tietä' },
      { url: 'johtaminen-vie-eteenpain', title: 'Johtaminen vie eteenpäin' },
      { url: 'opastusta-ja-neuvontaa-kayttajille', title: 'Opastusta ja neuvontaa käyttäjille' },
      { url: 'elinkeinoelama', title: 'Elinkeinoelämä' },
      { url: 'kiinteistoala', title: 'Kiinteistöala' },
      { url: 'kunta-ala', title: 'Kunta-ala' },
      { url: 'oljyala', title: 'Öljyala' },
      { url: 'muut-sopimusalat', title: 'Muut sopimusalat' },
      { url: 'sopimuksiin-iittyneet', title: 'Sopimuksiin liittyneet' }
    ];
    this.pagesEN = [
      { url: 'mita-ovat-energiatehokkuussopimukset', title: 'Energy efficiency agreements 2008–2016' },
      { url: 'ministerin-alkusanat', title: 'Minister\'s forewords' },
      { url: 'mita-saavutimme-vuosina-2008-2016', title: 'What was achieved during 2008-2016?' },
      { url: 'vapaaehtoisuuden-voimalla', title: 'The power of voluntary action' },
      { url: 'menestystekijat', title: 'Why do the agreements work?' },
      { url: 'takana-pitka-historia', title: 'The long history of the agreements' },
      { url: 'valtio-tukee-energiatehokkuutta', title: 'The government supports energy efficiency' },
      { url: 'energiakatselmus-viitoittaa-tieta', title: 'Energy audits pave the way' },
      { url: 'johtaminen-vie-eteenpain', title: 'Going forward with management' },
      { url: 'opastusta-ja-neuvontaa-kayttajille', title: 'Guidance and advice for users' },
      { url: 'elinkeinoelama', title: 'Industries – Industry, energy and service sector' },
      { url: 'kiinteistoala', title: 'Property and Building Sector' },
      { url: 'kunta-ala', title: 'Municipal sector' },
      { url: 'oljyala', title: 'Oil sector' },
      { url: 'muut-sopimusalat', title: 'Other agreement sectors' },
      { url: 'sopimuksiin-iittyneet', title: 'Participants' }
    ];
  }

  @HostListener('window:scroll', ['$event'])
  track(event) {
    if (document.getElementsByTagName('html')[0].scrollTop > 100) {
      if (!document.getElementById('nav').classList.contains('fixed')) {
        document.getElementById('nav').classList.add('fixed');
      }
    } else {
      if (document.getElementById('nav').classList.contains('fixed')) {
        document.getElementById('nav').classList.remove('fixed');
      }
    }
  }

  toggleLanguage() {
    /* Skip the super cool language toggle and just change the domain instead */
    const activeDomain = window.location.hostname === 'energyefficiencyagreements2008-2016.fi' ? 'energiatehokkuussopimukset2008-2016.fi' : 'energyefficiencyagreements2008-2016.fi';
    const activeSlug = this.router.url;
    window.location.href = 'https://' + activeDomain + activeSlug;

    /*
    if (this.miscService.inFinnishPlease === true) {
      this.miscService.toggleLanguage();
      this.FinnishSelected = false;
    } else {
      this.miscService.toggleLanguage();
      this.FinnishSelected = true;
    }
    */
  }

  toggleMenu() {
    this.menuActive = !this.menuActive;
    if (document.body.classList.contains('fixed')) {
      document.body.classList.remove('fixed');
      document.getElementById('burgerToggle').classList.remove('is-active');
    } else {
      document.body.classList.add('fixed');
      document.getElementById('burgerToggle').classList.add('is-active');
    }
  }


}



// WEBPACK FOOTER //
// /Users/ilu/projektit/ets-tuloksia/src/app/header/header.component.ts